<template>
  <div>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :bordered="false">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="资产编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入资产编码" allow-clear v-model="queryParam.assetCode" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="资产名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入资产名称" allow-clear v-model="queryParam.assetName" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="资产类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-tree-select
                      style="width: 100%"
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      allow-clear
                      treeDefaultExpandAll
                      :treeData="categoryTreeData"
                      v-model="queryParam.categoryId"
                      placeholder="请选择类别" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  </span>
                </a-col>
              </a-row>
              <a-row :gutter="24" style="margin-top: 8px;">
                <a-col :md="6" :sm="24">
                  <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择状态" allow-clear style="width: 100%" v-model="queryParam.status">
                      <a-select-option value="在用">在用</a-select-option>
                      <a-select-option value="闲置">闲置</a-select-option>
                      <a-select-option value="已处置">已处置</a-select-option>
                      <a-select-option value="已报废">已报废</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="启用日期" :labelCol="{ span: 6 }" :wrapperCol="{ span: 17 }">
                    <a-range-picker style="width: 100%" v-model="queryParam.dateRange" format="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']" @change="onDateChange" />
                  </a-form-item>
                </a-col>
                <a-col :md="10" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" icon="plus" v-if="btnEnableList.indexOf('1') > -1" @click="handleAdd">登记</a-button>
                    <a-button style="margin-left: 8px" icon="delete" v-if="btnEnableList.indexOf('1') > -1" @click="batchDel">删除</a-button>
                    <a-button style="margin-left: 8px" icon="download" v-if="btnEnableList.indexOf('3') > -1" @click="exportExcel">导出</a-button>
                    <a-button style="margin-left: 8px" icon="printer" @click="handlePrint('ZCKP')">打印卡片</a-button>
                    <a-button style="margin-left: 8px" icon="printer" @click="handlePrint('ZCBQ')">打印标签</a-button>
                    <a-button style="margin-left: 8px" icon="upload" v-if="btnEnableList.indexOf('1') > -1" @click="openImport">期初导入</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <!-- 本页汇总 -->
          <div style="margin-bottom: 8px; padding: 8px 12px; background: #fafafa; border: 1px solid #e8e8e8; border-radius: 4px;">
            <span style="font-weight: 500;">本页合计：</span>
            <span style="margin-left: 12px;">资产 {{ dataSource.length }} 条</span>
            <span style="margin-left: 24px;">原值 {{ formatNumber(pageSummary.originalValue) }}</span>
            <span style="margin-left: 24px;">累计折旧 {{ formatNumber(pageSummary.accumulatedDepreciation) }}</span>
            <span style="margin-left: 24px;">净值 {{ formatNumber(pageSummary.netValue) }}</span>
          </div>

          <a-table
            bordered
            ref="table"
            size="middle"
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="{ x: true }"
            :loading="loading"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }">
            <span slot="action" slot-scope="text, record">
              <a @click="handleView(record)">查看</a>
              <a-divider type="vertical" />
              <a v-if="record.status !== '已处置' && record.status !== '已报废'" @click="handleEdit(record)">编辑</a>
              <a-divider v-if="record.status !== '已处置' && record.status !== '已报废'" type="vertical" />
              <a-popconfirm title="确认删除该卡片?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </a-table>
          <a-row :gutter="24" style="margin-top: 8px; text-align: right">
            <a-col :md="24" :sm="24">
              <a-pagination
                @change="paginationChange"
                @showSizeChange="paginationShowSizeChange"
                size="small"
                show-size-changer
                show-quick-jumper
                :current="ipagination.current"
                :page-size="ipagination.pageSize"
                :page-size-options="ipagination.pageSizeOptions"
                :total="ipagination.total" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>

    <!-- 登记/编辑 -->
    <asset-card-modal ref="cardModal" @ok="loadData" />

    <!-- 详情 -->
    <asset-card-detail ref="cardDetail" />

    <!-- 期初导入 -->
    <a-modal title="期初资产导入" :width="560" :visible="importVisible" :footer="null" @cancel="closeImport">
      <a-alert style="margin-bottom: 12px;" type="info" show-icon
        message="导入的资产标记为期初资产（is_initial=1），不生成入账凭证；启用期间当月即提折旧。" />
      <div style="margin-bottom: 12px;">
        <a-button icon="download" @click="downloadTemplate">下载导入模板</a-button>
        <a-upload :showUploadList="false" :beforeUpload="beforeImportUpload" accept=".xls,.xlsx"
          style="display: inline-block; margin-left: 12px;">
          <a-button type="primary" icon="upload" :loading="importing">上传导入</a-button>
        </a-upload>
      </div>
      <template v-if="importResult">
        <a-alert style="margin-bottom: 8px;" :type="importResult.fail > 0 ? 'warning' : 'success'" show-icon
          :message="'导入完成：成功 ' + importResult.success + ' 条，失败 ' + importResult.fail + ' 条'" />
        <a-alert v-if="importResult.balanceTip" style="margin-bottom: 8px;" type="info" show-icon
          :message="importResult.balanceTip" />
        <div v-if="importResult.errors && importResult.errors.length"
          style="max-height: 240px; overflow: auto; border: 1px solid #e8e8e8; padding: 8px; border-radius: 4px;">
          <div v-for="(e, i) in importResult.errors" :key="i" style="color: #f5222d; line-height: 22px;">{{ e }}</div>
        </div>
      </template>
    </a-modal>
    <asset-bill-print ref="assetPrint" />
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { assetList, assetDelete, categoryList, importTemplate, importAsset } from './api/fixedAsset'
import AssetCardModal from './AssetCardModal.vue'
import AssetCardDetail from './AssetCardDetail.vue'
import AssetBillPrint from './AssetBillPrint.vue'

const exportHead = '序号,资产编码,资产名称,资产类别,规格型号,原值,月折旧额,累计折旧,净值,启用日期,状态,存放地点'

export default {
  name: 'AssetCardList',
  mixins: [JeecgListMixin],
  components: { AssetCardModal, AssetCardDetail, AssetBillPrint },
  data() {
    return {
      urlPath: '/plugin/fixed-asset/asset-card',
      labelCol: { span: 7 },
      wrapperCol: { span: 16, offset: 1 },
      queryParam: {
        assetCode: '',
        assetName: '',
        categoryId: undefined,
        status: undefined,
        beginTime: '',
        endTime: '',
        dateRange: []
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        total: 0
      },
      categoryTreeData: [],
      selectedRowKeys: [],
      selectionRows: [],
      columns: [
        { title: '序号', dataIndex: 'rowIndex', width: 60, align: 'center', customRender: (t, r, index) => index + 1 },
        { title: '资产编码', dataIndex: 'assetCode', width: 140, ellipsis: true },
        { title: '资产名称', dataIndex: 'assetName', width: 150, ellipsis: true },
        { title: '资产类别', dataIndex: 'categoryName', width: 110, ellipsis: true },
        { title: '规格型号', dataIndex: 'assetModel', width: 110, ellipsis: true },
        { title: '原值', dataIndex: 'originalValue', width: 100, align: 'right' },
        { title: '月折旧额', dataIndex: 'monthlyDepreciation', width: 100, align: 'right' },
        { title: '累计折旧', dataIndex: 'accumulatedDepreciation', width: 100, align: 'right' },
        { title: '净值', dataIndex: 'netValue', width: 100, align: 'right' },
        { title: '启用日期', dataIndex: 'startDate', width: 105, align: 'center' },
        { title: '状态', dataIndex: 'status', width: 80, align: 'center' },
        { title: '存放地点', dataIndex: 'location', width: 110, ellipsis: true },
        { title: '保管人', dataIndex: 'responsiblePerson', width: 90, ellipsis: true },
        { title: '转固单号', dataIndex: 'transBillNo', width: 130, ellipsis: true },
        { title: '操作', dataIndex: 'action', width: 170, align: 'center', scopedSlots: { customRender: 'action' }, fixed: 'right' }
      ],
      importVisible: false,
      importing: false,
      importResult: null
    }
  },
  computed: {
    pageSummary() {
      const s = { originalValue: 0, accumulatedDepreciation: 0, netValue: 0 }
      this.dataSource.forEach((r) => {
        s.originalValue += Number(r.originalValue || 0)
        s.accumulatedDepreciation += Number(r.accumulatedDepreciation || 0)
        s.netValue += Number(r.netValue || 0)
      })
      return s
    }
  },
  created() {
    this.loadCategoryTreeData()
  },
  methods: {
    loadCategoryTreeData() {
      categoryList().then((res) => {
        if (res && res.success && res.data) {
          this.categoryTreeData = this.convertTreeData(res.data, null)
        }
      })
    },
    convertTreeData(list, parentId) {
      return list
        .filter((r) => (r.parentId == null ? null : Number(r.parentId)) === parentId)
        .map((r) => ({
          key: r.id,
          value: r.id,
          title: r.name,
          children: this.convertTreeData(list, r.id)
        }))
    },
    onDateChange(value, dateString) {
      if (dateString && dateString.length === 2) {
        this.queryParam.beginTime = dateString[0]
        this.queryParam.endTime = dateString[1]
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    searchQuery() {
      this.ipagination.current = 1
      this.loadData()
    },
    searchReset() {
      this.queryParam = {
        assetCode: '', assetName: '', categoryId: undefined,
        status: undefined, beginTime: '', endTime: '', dateRange: []
      }
      this.ipagination.current = 1
      this.loadData()
    },
    loadData() {
      const params = {
        page: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        assetCode: this.queryParam.assetCode || null,
        assetName: this.queryParam.assetName || null,
        categoryId: this.queryParam.categoryId || null,
        status: this.queryParam.status || null,
        startDate: this.queryParam.beginTime || null,
        endDate: this.queryParam.endTime || null
      }
      this.loading = true
      assetList(params).then((res) => {
        if (res && res.success && res.data) {
          this.dataSource = (res.data.records || []).map((item) => ({ ...item, key: item.id }))
          this.ipagination.total = res.data.total || 0
        } else {
          this.$message.error((res && res.message) || '查询失败')
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.$message.error('查询失败')
      })
    },
    formatNumber(val) {
      if (val === null || val === undefined) return '0.00'
      return parseFloat(val).toFixed(2)
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    /** 已处置/已报废终态卡片不可勾选（防误操作） */
    getCheckboxProps(record) {
      return { props: { disabled: record.status === '已处置' || record.status === '已报废' } }
    },
    handleAdd() {
      this.$refs.cardModal.open({})
    },
    handleEdit(record) {
      this.$refs.cardModal.open(record)
    },
    handleView(record) {
      this.$refs.cardDetail.show(record)
    },
    handleDelete(id) {
      assetDelete(id).then((res) => {
        if (res && res.success) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.error((res && res.message) || '删除失败')
        }
      })
    },
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择要删除的卡片！')
        return
      }
      const that = this
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中的 ' + this.selectedRowKeys.length + ' 张卡片（含折旧明细与附件）?',
        onOk() {
          that.loading = true
          Promise.all(that.selectedRowKeys.map((id) => assetDelete(id))).then((results) => {
            const fail = results.filter((r) => !r || !r.success)
            if (fail.length === 0) that.$message.success('批量删除成功')
            else that.$message.warning('部分删除失败：' + (fail[0].message || ''))
            that.selectedRowKeys = []
            that.loadData()
          }).catch(() => {
            that.loading = false
            that.$message.error('删除失败')
          })
        }
      })
    },
    /** 批量打印卡片(ZCKP)/标签(ZCBQ)：勾选卡片逐张串行打印（模板含二维码取 assetCode） */
    async handlePrint(billTypeCode) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请先勾选要打印的资产卡片！')
        return
      }
      const rows = this.dataSource.filter((r) => this.selectedRowKeys.indexOf(r.id) > -1)
      const typeName = billTypeCode === 'ZCKP' ? '资产卡片' : '资产标签'
      for (const row of rows) {
        await this.$refs.assetPrint.show(row.assetCode, typeName, row, [])
        this.$refs.assetPrint.handlePrintPreview()
      }
      this.$message.success('已发送 ' + rows.length + ' 张' + typeName + '至打印')
    },
    exportExcel() {
      const list = this.dataSource.map((ds, i) => [
        i + 1,
        ds.assetCode || '',
        ds.assetName || '',
        ds.categoryName || '',
        ds.assetModel || '',
        ds.originalValue || 0,
        ds.monthlyDepreciation || 0,
        ds.accumulatedDepreciation || 0,
        ds.netValue || 0,
        ds.startDate || '',
        ds.status || '',
        ds.location || ''
      ])
      let tip = '查询条件'
      if (this.queryParam.assetCode) tip += ', 资产编码=' + this.queryParam.assetCode
      if (this.queryParam.assetName) tip += ', 资产名称=' + this.queryParam.assetName
      if (this.queryParam.status) tip += ', 状态=' + this.queryParam.status
      this.handleExportXlsPost('资产台账', '资产台账', exportHead, tip, list)
    },
    paginationChange(page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, size) {
      this.ipagination.current = 1
      this.ipagination.pageSize = size
      this.loadData()
    },
    // ==================== 期初导入 ====================
    openImport() {
      this.importResult = null
      this.importVisible = true
    },
    closeImport() {
      this.importVisible = false
      this.importResult = null
    },
    downloadTemplate() {
      importTemplate().then((data) => {
        if (!data) {
          this.$message.warning('模板下载失败')
          return
        }
        this.saveBlob(data, '期初资产导入模板.xls')
      }).catch(() => { this.$message.warning('模板下载失败') })
    },
    saveBlob(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    beforeImportUpload(file) {
      const formData = new FormData()
      formData.append('file', file)
      this.importing = true
      importAsset(formData).then((res) => {
        this.importing = false
        if (res && res.success) {
          this.importResult = res.data || { success: 0, fail: 0, errors: [] }
          this.ipagination.current = 1
          this.loadData()
        } else {
          this.$message.error((res && res.message) || '导入失败')
        }
      }).catch(() => {
        this.importing = false
        this.$message.error('导入失败')
      })
      return false
    }
  }
}
</script>
